// Copyright Materialize, Inc. and contributors. All rights reserved.
//
// Use of this software is governed by the Business Source License
// included in the LICENSE file.
//
// As of the Change Date specified in that file, in accordance with
// the Business Source License, use of this software will be governed
// by the Apache License, Version 2.0.

export const NAV_MIN_WIDTH_PX = 240;
export const NAV_MIN_HEIGHT_PX = 52;
export const NAV_HORIZONTAL_SPACING = 4;
export const NAV_HOVER_STYLES = {
  bg: "background.accent",
  color: "accent.brightPurple",
  "*": {
    color: "accent.brightPurple",
  },
};
